import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-801ae826"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "privacyHtml"
};
var _hoisted_2 = ["innerHTML"];
import Login from '@/api/pub';
import { VueCookieNext } from 'vue-cookie-next';
import { $rdoLang, $doLang } from '@/assets/common/common.js';
import { useRoute } from 'vue-router';
import _get from 'lodash/get';
export default {
  setup: function setup(__props) {
    var privacyHtml = ref('');
    var route = useRoute();
    var cookie = VueCookieNext;
    var type = ref(_get(route.query, 'type', ''));
    var lang = ref(_get(route.query, 'lang', ''));
    var title = ref('privacyPolicy');
    lang.value = $doLang(lang.value);
    switch (type.value) {
      case 'privacy':
        title.value = 'privacyPolicy';
        break;
      case 'personalPolicy':
        title.value = 'personalPolicy';
        break;
      case 'promotionPolicy':
        title.value = 'promotionPolicy';
        break;
      case 'termsOfUse':
        title.value = 'termsOfUsePolicy';
        break;
      case 'orgDissolveNotice':
        title.value = 'orgDissolveNotice';
        break;
      case 'dataMigrateNotice':
        title.value = 'dataMigrateNotice';
        break;
      default:
        type.value = 'privacy';
        break;
    }
    console.log(lang.value || cookie.getCookie('lang') || 'zh-cn');
    console.log($rdoLang(lang.value || cookie.getCookie('lang') || 'zh-cn'));
    Login.getOigpc($rdoLang(lang.value || cookie.getCookie('lang') || 'zh-cn'), _get(route.query, 'oem') || VueCookieNext.getCookie('oemURL') || 'index', type.value || 'privacy').then(function (res) {
      if (res.status === 'success') {
        privacyHtml.value = res.result;
      } else {
        privacyHtml.value = '';
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [privacyHtml.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "ppHtml",
        innerHTML: privacyHtml.value
      }, null, 8, _hoisted_2)) : _createCommentVNode("", true)]);
    };
  }
};